import ComponentMixin from '../smart/component.m.js';

class Base extends HTMLElement {
    constructor(...args) {
        super(...args);
    }
}

class TabsContainer extends ComponentMixin(Base) {

    constructor(...args) {
        // Constructor caveat https://github.com/WebReflection/document-register-element/
        const _ = super(...args);
        return _;
    }

    setup() {
        super.setup();
        this.on(['tabclick', 'tabkeydown']);
    }

    ontabclick(e) {
        var newActiveTab = e.target;
        var oldActiveTab = this.querySelector('[target-id][active]');

        if (newActiveTab === oldActiveTab) {
            return;
        }

        if (oldActiveTab) {
            oldActiveTab.active = false;
            this.hideOldTarget(oldActiveTab.targetId);
        }

        newActiveTab.active = true;

        this.showNewTarget(newActiveTab.targetId);

        this.preventEvent(e);
    }
    hideOldTarget(oldTargetId) {

        var oldActiveTarget = this.querySelector('[source-id="' + oldTargetId + '"][active]') || document.querySelector('[source-id="' + oldTargetId + '"][active]');
        if (oldActiveTarget) {
            oldActiveTarget.style.display = 'none';
            oldActiveTarget.removeAttribute('active');
            return;
        }

    }
    showNewTarget(targetId) {
        var newTarget = this.querySelector('[source-id="' + targetId + '"]') || document.querySelector('[source-id="' + targetId + '"]');
        if (newTarget) {
            newTarget.style.display = 'block';
            newTarget.setAttribute('active', '');
            return;
        }

    }
    ontabkeydown(event) {
        switch (event.detail.key) {
            case "Down": // IE/Edge specific value
            case "ArrowDown":
                if(!this.classList.contains('zs-tabs-vertical')){
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                this.navigateNext(event.target);
                break;
            case "Up": // IE/Edge specific value
            case "ArrowUp":
                if(!this.classList.contains('zs-tabs-vertical')){
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                this.navigatePrevious(event.target);
                break;
            case "Left": // IE/Edge specific value
            case "ArrowLeft":
                if(this.classList.contains('zs-tabs-vertical')){
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                this.navigatePrevious(event.target);
                break;
            case "Right": // IE/Edge specific value
            case "ArrowRight":
                if(this.classList.contains('zs-tabs-vertical')){
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                this.navigateNext(event.target);
                break;
            case "Enter":
                event.preventDefault();
                event.stopPropagation();
                this.ontabclick(event);
                break;
        }

    }

    navigateNext(target) {
        var nextTarget = target.nextElementSibling;
        nextTarget && nextTarget.focus();
    }
    navigatePrevious(target) {
        var nextTarget = target.previousElementSibling;
        nextTarget && nextTarget.focus();
    }
}

TabsContainer.is = 'zs-tabs-container';

class Tab extends ComponentMixin(Base) {

    constructor(...args) {
        // Constructor caveat https://github.com/WebReflection/document-register-element/
        const _ = super(...args);
        return _;
    }

    setup() {
        super.setup();
        this._active = false;
        this.syncProp('active');
        this.syncProp('targetId');
        this.on(['click', 'keydown']);
    }
    render() {
        this.active ? this.setAttribute('tabindex', '0') : this.setAttribute('tabindex', '-1');
    }
    static get observedAttributes() {
        return super.observedAttributes.concat(['active', 'target-id']);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        switch (name) {
            case 'active':
                if (newValue !== null) {
                    this.classList.add('zs-active');
                    this.setAttribute('tabindex', '0');
                } else {
                    this.classList.remove('zs-active');
                    this.setAttribute('tabindex', '-1');
                }
                this.syncAttr(name, newValue, 'boolean');
                break;
            default:
                this.syncAttr(name, newValue, 'string');
        }
    }

    onclick() {
        this.fire('tabclick', { bubbles: true });
    }
    onkeydown(event) {
        this.fire('tabkeydown', { bubbles: true, detail: { 'key': event.key } });
        //to avoid scrolling of page
        switch (event.key) {
            case "Right": // IE/Edge specific value
            case "ArrowRight":
            case "Left": // IE/Edge specific value
            case "ArrowLeft":
            case "Down": // IE/Edge specific value
            case "ArrowDown":
            case "Up": // IE/Edge specific value
            case "ArrowUp":
                event.preventDefault();
                event.stopPropagation();
                break;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        window.requestAnimationFrame(() => {
            this.render();
        })
    }
}

Tab.is = 'zs-tab';

export default { TabsContainer, Tab }